import React, { useState, Children } from 'react';
import { number, string, func, node, oneOfType, bool } from 'prop-types';
import classNames from 'classnames';
import { warning } from '../../utils';
import { getActiveTabIndex } from './utils';
import Tab from './Tab';
import { WITHOUT_SCROLL_CLASS } from './constants';

import './index.scss';

const ALLOWED_CHILD_TYPE = 'Tab';

const getChildTypeErrorMessage = (type) =>
    `Warning: TabGroup supports only children of type ${ALLOWED_CHILD_TYPE}, ${type} received instead. Component may render incorrectly.`;

/**
 * @deprecated Please use TabGroup from @fiverr-private/navigation instead.
 */
const TabGroup = ({
    activeTab = 0,
    onSwitch = Function.prototype,
    children,
    hideMobileScrollbar = false
}) => {
    const [activeTabIndex, setActiveIndex] = useState(getActiveTabIndex(children, activeTab));

    return (
        <div className="orca-tabs">
            <ul className={classNames('tab-buttons', {
                [WITHOUT_SCROLL_CLASS]: hideMobileScrollbar
            })}>
                {Children.map(children, (child, index) => {
                    if (child.type.name !== ALLOWED_CHILD_TYPE) {
                        warning(getChildTypeErrorMessage(child.type.name));
                    }
                    return React.cloneElement(child, {
                        active: index === activeTabIndex,
                        onClick: () => {
                            setActiveIndex(index);
                            onSwitch(index, child.props.name);
                        }
                    });
                })}
            </ul>
            <div className="tab-content">
                {children[activeTabIndex].props.children}
            </div>
        </div>
    );
};

TabGroup.displayName = 'TabGroup';

TabGroup.propTypes = {

    /**
     * Index or name of the tab selected by default
     */
    activeTab: oneOfType([number, string]),

    /**
     * A handler that fires when the tab is switched.
     * @param index - Index of the selected tab
     * @param name - Name of the selected tab
     */
    onSwitch: func,

    /**
     * Tab content
     */
    children: node.isRequired,

    /**
     * A flag to control hiding scroll on mobile.
     */
    hideMobileScrollbar: bool
};

TabGroup.defaultProps = {
    activeTab: 0,
    hideMobileScrollbar: false
};

export default TabGroup;

export { Tab };
